/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import 'react-telephone-input/css/default.css';
import styles from './login.module.scss';

export default function MailPasswordForm({
    handleInputChange,
    handleLogin,
    errors,
    handleInputBlurred,
    blurredFields,
    cognitoPhoneError,
    password,
    email,
    handleGoBack,
    isSSO
}) {
  return (
    <form name="loginForm" className={styles.login_form} onSubmit={handleLogin} noValidate>
        <div className={styles.login_form_wrapper}>
            <div className={styles.welcome}>
                {<FormattedMessage id="authentication.login.authentication" defaultMessage="Authentication" />}
            </div>
            {isSSO?.includes('password') && (
            <>
                <div className={styles.login_message}>Please, enter your password to login</div>
                <div className={styles.column_wrapper}>
                    <div className={styles.form_column}>
                        <label htmlFor="loginPassword">
                            <div style={{ display: 'flex' }}>
                                <span>{email}</span>
                                <div style={{ color: 'blue', marginLeft: '1rem' }} onClick={() => handleGoBack('mailLogin')}>Change</div>
                            </div>
                            <div className={styles.form_control}>
                                <input
                                    placeholder="Password"
                                    type="password"
                                    name="loginPassword"
                                    required
                                    value={password}
                                    onChange={(e) => { handleInputChange('password', e.target.value); }}
                                    onBlur={() => { handleInputBlurred('password'); }}
                                />
                            </div>
                        </label>
                        {blurredFields.phone && errors.phoneEmpty ? (
                        <small className={styles.error}>
                            <FormattedMessage id="authentication.login.error.email_empty" defaultMessage="This field cannot be empty" />
                        </small>
                        ) : null}
                        {blurredFields.phone && cognitoPhoneError ? (
                        <small className={styles.error}>
                            <FormattedMessage
                                id="authentication.login.cognito.phone_error"
                                defaultMessage={`The phone number you entered is not registered in the system.
                                    Please try again with another number or contact your system administrator.`}
                            />
                        </small>
                        ) : null}
                        {!blurredFields.phone || (!errors.phoneEmpty && !errors.phoneInvalid) ? (
                        <small className={styles.empty_error} />
                        ) : null}
                    </div>
                </div>
                {errors.invalidCredentials ? (
                <div className={`${styles.error} ${styles.invalid_credentials}`}>
                    <FormattedMessage id="authentication.login.error.invalid_credentials" defaultMessage="Invalid Credentials" />
                </div>) : null}
                <div className={styles.button_wrapper}>
                    <button
                        type="submit"
                        className={styles.button}
                        category="password"
                    >
                        <FormattedMessage id="authentication.login.login" defaultMessage="Login" />
                    </button>
                </div>
            </>)}
            {isSSO?.includes('sso') && (
                <>
                    {!isSSO?.includes('password') && (
                    <div className={styles.column_wrapper}>
                        <div className={styles.form_column}>
                            <label htmlFor="loginPassword">
                                <span style={{ fontSize: '1.2rem', color: 'black' }}>{email}</span>
                                <div
                                    style={{ color: 'blue', marginLeft: '1rem', float: 'right' }}
                                    onClick={() => handleGoBack('mailLogin')}
                                >
                                    Change
                                </div>
                            </label>
                        </div>
                    </div>)}
                    <div className={styles.button_wrapper} style={{ marginTop: isSSO?.includes('password') ? 0 : 'intial' }}>
                        <button
                            type="submit"
                            category="sso"
                            className={styles.button}
                        >
                            <FormattedMessage id="authentication.login.login_sso" defaultMessage="Login (SSO)" />
                        </button>
                    </div>
                </>
            )}
        </div>
    </form>
  );
}
